(function () {
    'use strict';

    angular
        .module('app')
        .controller('SharePopupController', SharePopupController);

    SharePopupController.$inject = ['$scope', '$state', 'dialog', '$http'];

    function SharePopupController($scope, $state, dialog, $http) {
        var vm = this;

        vm.copyLink = copyLink;
        vm.closeSharePopup = closeSharePopup;

        vm.$onInit = function () {
            if (vm.type == 'concert') {
                vm.concert = vm.data;
            }/* 
            if (vm.type == 'space') {
                vm.space = vm.data;
            }
            if (vm.type == 'artist') {
                vm.band = vm.data;
            } */
            vm.concert_link = "https://www.bemyconcert.com/concert/" + vm.data.concert_slug;

            vm.mailto_link = "mailto:" + "" +
                "?subject=" + vm.data.concert_name + " - Be My Concert" +
                "&body=" + vm.concert_link;
        }


        function copyLink() {
            navigator.clipboard.writeText(vm.concert_link);
            vm.link_copied = 1;
        }

        function closeSharePopup() {
            vm.link_copied = 0;
            vm.show = 0;
        }

    }
})();

